module.exports = __webpack_public_path__ + "img/battery-serious.0791afd5.svg";